module.exports = __webpack_public_path__ + "img/01.59d2810c.jpg";